import React from 'react';
import {useTranslation} from 'react-i18next';
import {Space} from 'antd';
import PropTypes from 'prop-types';
import {StyledInvoiceRetrieval, StyledInvoiceRetrievalCopyField} from './StyledInvoiceRetrieval';
import {alertActions} from '../../../../../state/actions/alert.actions';
import {FileIcon} from '../../../../../icons';

const InvoiceRetrieval = ({
  email,
  ...rest
}) => {
  const [trans] = useTranslation(['main', 'settings']);
  const t = (key) => trans(`settings:tabs.invoiceRetrieval.${key}`);

  const onCopy = () => alertActions.success(`${trans('copied')}!`);

  return (
    <StyledInvoiceRetrieval
      {...rest}
    >
      <Space size='small' align='center'>
        <FileIcon />
        <h3>{t('title')}</h3>
      </Space>
      {email ? (
        <>
          <p>{t('description')}</p>
          <StyledInvoiceRetrievalCopyField
            onCopy={onCopy}
            label={trans('address')}
            value={email}
          />
        </>
      ) : (
        <p>{trans('invoiceEmailEmptyDescription')}</p>
      )}
    </StyledInvoiceRetrieval>
  );
}

InvoiceRetrieval.propTypes = {
  email: PropTypes.string
}

export default InvoiceRetrieval;
